import React from "react";
import BasicHeader from "../../components/mui/containers/basicHeader";

const Header = () => {
  const header = {
    title: "Agentic AI Ad-Operations Ecosystem",
    article:
      "Our autonomous AI Agents manage your entire demand stack, self-optimizing AuctionX™ in real-time to eliminate manual overhead and maximize yield.",
    picsrc: "images/publishers/publisher-header.png",
    iconsrc: "images/buyers/buyer-icon.png",
    imagesrc: "images/publishers/finalist-badge.png",
    imagelink:
      "https://digiday.com/announcement/awards/in-the-know-vox-media-insider-and-theskimm-are-among-this-years-digiday-media-awards-finalists/",
  };
  return (
    <BasicHeader
      title={header.title}
      article={header.article}
      imagesrc={header.imagesrc}
      imagelink={header.imagelink}
      button={false}
      divider={true}
      long={false}
      picsrc={header.picsrc}
      iconsrc={header.iconsrc}
    />
  );
};

export default Header;
